import {
    Switch,
    Route,
    useHistory,
    useRouteMatch,
  } from "react-router-dom";
import Event from "./Event";
import EventShare from "./EventShare";
import { firestore } from "./firebase";
import Fusion from "./Fusion";
import Sidebar from "./Sidebar";

export default function Events() {
    const history = useHistory();

    const newEvent = () => {
        const reference = firestore.collection('events').doc();
        history.push(`/events/${reference.id}`);
    };

    let match = useRouteMatch();
    
    return <div className="h-full flex w-auto">
        <Sidebar newItem={newEvent} newItemText="Neues Event" collection="events" showSearch={true} itemTitle={(item) => item.name} itemSubtitle={(item) => new Date((item.start?._seconds??item.start?.seconds??0) * 1000).toLocaleString('de-DE')} itemLink={(item) => `/events/${item.objectID}`} orders={[
            {
                id: 'upcoming',
                label: 'Kommende Events',
                field: 'start',
                direction: 'asc',
                fromNow: true,
            },
            {
                id: 'past',
                label: 'Vergangene Events',
                field: 'start',
                direction: 'desc',
                fromNow: true,
            },
        ]} defaultOrder="upcoming" />
        <div className="flex-grow overflow-auto">
            <Switch>
                <Route path={`${match.path}/:id/share`} component={EventShare} />
                <Route path={`${match.path}/:id1/fusion/:id2`}><Fusion collection="events" recordType="event" /></Route>
                <Route path={`${match.path}/:id1/fusion`}><Fusion collection="events" recordType="event" /></Route>
                <Route path={`${match.path}/:id`} component={Event} />
                <Route path={match.path}>
                    <p className="p-3">
                        Bitte selektiere ein Event.
                    </p>
                </Route>
            </Switch>
        </div>
    </div>;
}